import { MainMenuApi as api } from '../api/api.js'

export default {
  components: {
    'context-menu': () => import('../components/dialogs/contextMenu.vue'),
    'share-dialog': () => import('../components/dialogs/shareDialog.vue'),
    'rename-dialog': () => import('../components/dialogs/renameDialog.vue')
  },
  data: () => ({
    x: 0,
    y: 0,
    showContextMenu: false,
    selectItem: undefined,
    showShareDialog: false,
    showRenameDialog: false,
    fullPathText: undefined,
    fullPathUrl: undefined,
    caption: ''
  }),
  methods: {
    openContextMenu(item, event) {
      this.x = event.clientX
      this.y = event.clientY
      this.showContextMenu = true
      this.selectItem = item
      if (!this.isDrListViewNormal) {
        this.$emit('changeContextMenuItem', item.codeMenu)
      }

      event.preventDefault()
    },
    openInNewTab() {
      if (this.selectItem.httpLink) {
        window.open(this.selectItem.httpLink)
        return
      }
      window.open(`${this.baseUrl}/?${this.selectItem.shareParams}`)
    },
    async toShare() {
      let { fullPathText, fullPathUrl} = await this.getFullPath(this.selectItem.codeMenu, this.selectItem.shareParams)
      this.fullPathText = fullPathText
      this.fullPathUrl = fullPathUrl
      this.showShareDialog = true
    },
    async removeFromFavorite() {

      let response = await api.removeFromFavorite(this.selectItem.codeMenu)
      let result = response.data.iTEnterpriseMenuMutation.removeFromFavorite
      if (!result.success) {
        console.error(result.errorMessage)
        return
      }
      this.$emit('removeFromFavorite', this.selectItem.codeMenu)
    },
    async renameFunctionMenu(caption) {
      let response = await api.renameFunctionMenu(this.selectItem.npp, caption)
      let result = response.data.iTEnterpriseMenuMutation.renameFunctionMenu
      if (!result.success) {
        console.error(result.errorMessage)
        return
      }

      this.$emit('renameListViewItem', { codeMenu: this.selectItem.codeMenu, caption: caption })
      this.showRenameDialog = false
    },
    async addToFavorite() {
      let response = await api.addToFavorite(this.selectItem.codeMenu)
      let result = response.data.iTEnterpriseMenuMutation.addToFavorite

      if (!result.success) {
        console.error(result.errorMessage)
        return
      }
      this.$emit('addToFavorite', this.selectItem)
    },
    openRenameDialog() {
      this.showRenameDialog = true
      this.caption = this.selectItem.name
    },
    closeDialog() {
      this.showRenameDialog = this.showShareDialog = false
      this.selectItem = undefined
    },
    async getFullPath(codeMenu, startParams) {
      let response = await api.getFullPath(codeMenu, startParams)
      return response.data.iTEnterpriseMenuQuery.fullPath
    },

    menuSettingsAccess(allUsers) {
      if (window.parent && window.parent.postMessage && window.parent != window) {
        window.parent.postMessage({ type: 'CallMainMenuSettingsAccess', codeMenu: this.selectItem.codeMenu, allUsers: allUsers }, '*')
        return
      }
    }
  }
}